import { AggregationType } from "./fields";
import { Period } from "./period";
import { Filter } from "./records";
import { Right } from "./Users";

type ViewType = "GRID";
export const GRID: ViewType = "GRID";

export type SortType = "ASC" | "DESC" | "NONE";
export const ASC: SortType = "ASC";
export const DESC: SortType = "DESC";
export const NONE: SortType = "NONE";

export type SplitBySortType = SortType | "VALUE_ASC" | "VALUE_DESC";
export const VALUE_ASC: SplitBySortType = "VALUE_ASC";
export const VALUE_DESC: SplitBySortType = "VALUE_DESC";


export type GroupDisplayType = "Top" | "Left";
export const TOP: GroupDisplayType = "Top";
export const LEFT: GroupDisplayType = "Left";

// View represents a way of display records of a given object
// A view is attached to an object.
export interface View {
	_key: string;
	ownerKey: string | null;
	order: number | null;
	name: string;
	type: ViewType;
	filter: Filter | null;
	groups: Group[] | null;
	shownPaths: string[] | null;
	sortings: Sorting[] | null;
	pivot: Pivot | null;
	shared: boolean;
	aggregations: Map<string, AggregationType> | null;
	summaries: Summary[] | null;
	stickyPathKey: string | null;
	fieldOrder: string[] | null;
	formats: Map<string, Map<string, any>> | null;
	period: Period | null;

	// Deprecated: use shownPaths instead
	hiddenPaths: string[] | null;
}

// Summary is the aggregation displayed for a numeric column in the summary
// lines of a view: the last line of the table and, when the view is grouped,
// one line per group.
export interface Summary {
	pathKey: string;
	aggregation: AggregationType;
}

export interface Group {
	pathKey: string;
	sort: SortType;
	hideEmptyGroups: boolean;
	displayType: GroupDisplayType;
	applyGroupFilter: boolean;
	filter: Filter | null;
	// hideSummaries hides the view summaries on this group's lines (absent =
	// displayed, the default)
	hideSummaries?: boolean;
}

export interface Sorting {
	pathKey: string;
	sort: SortType;
}

export interface Pivot {
	pivotPathKey: string | null;
	valuePathKeys: string[] | null;
}

export interface ShareViewRequest {
	viewKey: string;
	roleKey?: string;
	userKey?: string;
	right: Right | null;
}

export interface TransferViewOwnerRequest {
	newOwnerKey: string;
}
